import React from 'react'
import Header from '../components/Header/Header'
import Hajar from '../components/attendance/Hajar'

function Attendance() {
  return (
    <div>
        <Header/>
        <Hajar/>
    </div>
  )
}

export default Attendance